import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';

export default class Kontakt extends React.Component<RouteComponentProps<{}>, {}> {

  render() {
    return (
      <div className="kontakt maxwidth">
        <h2>Kontakt</h2>
        <p>Bei technischen Fragen oder Problemen erreichen Sie uns wie folgt:</p>
        <ul className="list-unstyled">
          <li><Glyphicon glyph="earphone" /> 0681 9987-777</li>
          <li><Glyphicon glyph="envelope" /> <a href="mailto:laborportal@diq-zert.de">laborportal@diq-zert.de</a></li>
        </ul>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Kontakt.tsx